import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import classNames from 'classnames';

const DraggableItem = ({ children, id, className, ...rest })=>{
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
        id,
        ...rest
    });
    const style = useMemo(()=>({
            transform: CSS.Transform.toString(transform),
            transition,
            cursor: rest.disabled === true ? 'not-allowed' : 'pointer'
        }), [
        transform,
        transition,
        rest.disabled
    ]);
    return jsx("div", {
        ref: setNodeRef,
        className: classNames('cb-draggable-list-item', className),
        style: style,
        ...attributes,
        ...listeners,
        ...rest,
        children: children
    });
};
DraggableItem.displayName = 'Draggable.Item';

export { DraggableItem };
//# sourceMappingURL=Draggable.Item.es.js.map
